app.factory('simulatorService', ['$rootScope', '$log', '$window', function ($rootScope, $log, $window) {
	var service = this;

	service.isIE = function() {
		var ua = $window.navigator.userAgent;
		return window.navigator.userAgent.indexOf("Trident") != -1
	}

	service.showWithExercise = function(exercise, questionIndex) {
		$log.debug("simulatorService: showWithExercise...");

		if (service.isIE()) {
			$log.debug("simulatorService: browser is IE, showing alert.");
			$window.alert("Forhåndsvisning fungerer ikke i Internet Explorer");
			return;
		}

		window.localStorage.setItem("simulatorExercise", JSON.stringify(exercise));
		window.localStorage.setItem("simulatorExerciseQuestionIndex", "" + questionIndex);
		window.localStorage.setItem("simulatorExerciseEvalQuestionIndex", "" + 0);
		window.localStorage.setItem("simulatorFullFlow", "false");

		$rootScope.$broadcast("simulatorShowExercise", {});
	}

	service.showWithEvalExercise = function(exercise, questionIndex) {
		$log.debug("simulatorService: showWithEvalExercise...");

		if (service.isIE()) {
			$log.debug("simulatorService: browser is IE, showing alert.");
			$window.alert("Forhåndsvisning fungerer ikke i Internet Explorer");
			return;
		}

		window.localStorage.setItem("simulatorExercise", JSON.stringify(exercise));
		window.localStorage.setItem("simulatorExerciseQuestionIndex", "" + 0);
		window.localStorage.setItem("simulatorExerciseEvalQuestionIndex", "" + questionIndex);
		window.localStorage.setItem("simulatorFullFlow", "false");

		$rootScope.$broadcast("simulatorShowEvalExercise", {});
	}

	service.showFullExerciseFlowWithExercise = function(exercise) {
		$log.debug("simulatorService: showFullExerciseFlowWithExercise...");

		if (service.isIE()) {
			$log.debug("simulatorService: browser is IE, showing alert.");
			$window.alert("Forhåndsvisning fungerer ikke i Internet Explorer");
			return;
		}

		window.localStorage.setItem("simulatorExercise", JSON.stringify(exercise));
		window.localStorage.setItem("simulatorExerciseQuestionIndex", "" + 0);
		window.localStorage.setItem("simulatorExerciseEvalQuestionIndex", "" + 0);
		window.localStorage.setItem("simulatorFullFlow", "true");

		$rootScope.$broadcast("simulatorShowFullExerciseFlowWithExercise", {});
	}
	
	return service;

}]);
